import React from "react";
import "./CSS/FuelStory.css";

const features = [
  "Readings",
  "Reconciliation",
  "Customer Credit",
  "Cash Tracing",
  "Stock",
  "Reports",
];

function StationSet() {
  return (
    <div className="fs-station-set">
      <div className="fs-sun" />
      <div className="fs-cloud fs-cloud-a" />
      <div className="fs-cloud fs-cloud-b" />
      <div className="fs-station">
        <div className="fs-canopy">
          <span>FuelFlow</span>
        </div>
        <div className="fs-column fs-column-a" />
        <div className="fs-column fs-column-b" />
        <div className="fs-pump fs-pump-a">
          <span>Diesel</span>
        </div>
        <div className="fs-pump fs-pump-b">
          <span>Petrol</span>
        </div>
      </div>
      <div className="fs-road">
        <span />
        <span />
        <span />
      </div>
      <div className="fs-truck">
        <div className="fs-truck-cab" />
        <div className="fs-truck-body">
          <span>LOGISTICS</span>
        </div>
        <div className="fs-wheel fs-wheel-a" />
        <div className="fs-wheel fs-wheel-b" />
      </div>
    </div>
  );
}

function OperatorFlow() {
  return (
    <div className="fs-operator-flow">
      <div className="fs-operator">
        <div className="fs-person-head" />
        <div className="fs-person-body" />
        <div className="fs-person-arm fs-person-arm-a" />
        <div className="fs-person-arm fs-person-arm-b" />
      </div>
      <div className="fs-fuel-pump-large">
        <div className="fs-meter">
          <span>55.27 L</span>
          <strong>Done</strong>
        </div>
      </div>
      <div className="fs-hose" />
      <div className="fs-nozzle" />
      <div className="fs-phone-card">
        <img src="/fuelFlowLogo.png" alt="" />
        <span>Reading saved</span>
        <strong>Diesel 55.27 L</strong>
        <small>Cash, UPI, Card, Credit</small>
      </div>
      <div className="fs-fuel-stream">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

function ManagerDashboard() {
  return (
    <div className="fs-manager-dashboard">
      <div className="fs-office-wall">
        <div className="fs-office-window" />
        <div className="fs-office-light" />
      </div>
      <div className="fs-manager">
        <div className="fs-person-head" />
        <div className="fs-person-body" />
      </div>
      <div className="fs-desk" />
      <div className="fs-monitor">
        <div className="fs-app-header">
          <img src="/fuelFlowLogo.png" alt="" />
          <span>FuelFlow</span>
        </div>
        <div className="fs-kpi-grid">
          <div><span>Total Sale</span><strong>8.42L</strong></div>
          <div><span>Cash</span><strong>2.16L</strong></div>
          <div><span>Credit</span><strong>1.04L</strong></div>
          <div><span>Stock</span><strong>OK</strong></div>
        </div>
        <div className="fs-chart-row">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}

function ReportsAutomation() {
  return (
    <div className="fs-reports-automation">
      <div className="fs-report-card fs-report-main">
        <div className="fs-report-topline">
          <span>Daily Reconciliation</span>
          <strong>Ready</strong>
        </div>
        <div className="fs-report-bars">
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="fs-report-table">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className="fs-report-card fs-report-side">
        <span>WhatsApp Summary</span>
        <strong>Sent</strong>
      </div>
      <div className="fs-export-chip fs-export-a">PDF</div>
      <div className="fs-export-chip fs-export-b">Excel</div>
      <div className="fs-message-bubble">
        <span>FuelFlow Summary</span>
        <strong>Sales, credit, cash and stock shared.</strong>
      </div>
    </div>
  );
}

function FinalFrame() {
  return (
    <div className="fs-final-frame">
      <div className="fs-final-ring" />
      <img src="/fuelFlowLogo.png" alt="FuelFlow" />
      <h1>FuelFlow</h1>
      <p>Run your bunk with clarity.</p>
      <div className="fs-final-tags">
        {features.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
    </div>
  );
}

function FuelStory() {
  return (
    <main className="fuel-story-page">
      <section className="fs-video-stage" aria-label="FuelFlow animated marketing video">
        <div className="fs-film-grain" aria-hidden="true" />
        <div className="fs-bg-grid" aria-hidden="true" />

        <div className="fs-scene fs-scene-intro">
          <img src="/fuelFlowLogo.png" alt="" />
          <h1>FuelFlow</h1>
          <p>One place for readings, reconciliation, credits, stock and profit.</p>
        </div>

        <div className="fs-scene fs-scene-station">
          <StationSet />
          <div className="fs-caption fs-caption-left">
            <span>Morning starts fast</span>
            <strong>Every pump, every sale, every rupee needs clarity.</strong>
          </div>
        </div>

        <div className="fs-scene fs-scene-operator">
          <OperatorFlow />
          <div className="fs-caption fs-caption-right">
            <span>Operator flow</span>
            <strong>Readings, fuel, lube and settlement modes captured on mobile.</strong>
          </div>
        </div>

        <div className="fs-scene fs-scene-manager">
          <ManagerDashboard />
          <div className="fs-caption fs-caption-left">
            <span>Manager view</span>
            <strong>Reconciliation becomes a guided review instead of a late-night chase.</strong>
          </div>
        </div>

        <div className="fs-scene fs-scene-reports">
          <ReportsAutomation />
          <div className="fs-caption fs-caption-right">
            <span>Reports that move</span>
            <strong>Cash, credit, passbook, stock and profit reports are ready to share.</strong>
          </div>
        </div>

        <div className="fs-scene fs-scene-final">
          <FinalFrame />
        </div>

        <div className="fs-progress" aria-hidden="true">
          <span />
        </div>
      </section>
    </main>
  );
}

export default FuelStory;
